import React from 'react';
import { Grid, Paper, Box, Divider } from '@material-ui/core';
import MDXParser from './mdxParser';
import Img from './wrappedImage';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
    },
    container: {
      display: 'flex',
    },
    imageContainer: {
      display: 'flex',
      maxHeight: '800px',
    },
    title: {
      color: 'white',
      padding: '60px 0px 0 0',
    },
    text: {
      padding: '0px 0px 40px 0',
      color: 'white',
    },
    image: {
      width: '100%',
      maxWidth: '100%',
      height: 'auto',
      objectFit: 'contain',
    },
    flex: {
      display: 'flex',
    },
  }),
);

type Props = { children: React.ReactNode; image: any; title: string; color: string, copyText: string };

const IntroDetail = (props: Props) => {
  const classes = useStyles();

  return (
    <Container
      maxWidth={false}
      disableGutters={true}
      className={classes.root}
      style={{
        backgroundColor: props.color,
      }}
    >
      <Container className={classes.container}>
        <Grid container spacing={3} className={classes.flex}>
          <Grid item xs={12} md={6}>
            <Typography variant="h3" className={classes.title}>
              {props.title}
            </Typography>
            <div className={classes.text}>
                <MDXParser linkColor="white">{props.children}</MDXParser>
            </div>
          </Grid>
          <Grid item xs={12} md={6} className={classes.imageContainer}>
            <Img fluid={props.image.childImageSharp.fluid} className={classes.image} copyText={props.copyText} alt="Image" />
          </Grid>
        </Grid>
      </Container>
    </Container>
  );
};

export default IntroDetail;
